<template>
  <div>
    <Card dis-hover>

      <div class="query">
        <!-- <Divider orientation="left" style="position: relative;top: -12px;">查询条件
        </Divider> -->
        <Form :model="queryForm" label-position="right" ref="infoFrom" :label-width="120" inline>
          <FormItem prop="applicationNo" label="流水号">
            <Input type="text" v-model.trim="queryForm.applicationNo" placeholder="请输入" style="width: 200px">
            </Input>
          </FormItem>
          <FormItem prop="applicantName" label="申请人姓名">
            <Input type="text" v-model.trim="queryForm.applicantName" placeholder="请输入" style="width: 200px">
            </Input>
          </FormItem>
          <FormItem prop="wxOpenld" label="申请人身份证号">
            <Input type="text" v-model.trim="queryForm.applicantIDCardNo" placeholder="请输入" style="width: 200px">
            </Input>
          </FormItem>

          <FormItem prop="time" label="业务状态">
            <Select v-model="queryForm.status" style="width:200px">
              <Option value=""> -- </Option>
              <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.text }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem prop="time" label="申请时间">
            <DatePicker type="daterange" @on-change="dateChange()" :editable="false" v-model="queryForm.time" :start-date="new Date()" placement="bottom-end" placeholder="请选择" style="width: 200px" />
          </FormItem> -->

          <FormItem class="button function">
            <Button type="primary" @click="queryTable()" icon="md-search">查询</Button>

            <Button @click="refresh('infoFrom')" icon="md-refresh">重置</Button>
          </FormItem>
        </Form>
      </div>
      <div class="table_btn">

        <div class="tab_a" id="printDiv">
          <Table border stripe :loading="loading" ref="selection" no-data-text="暂无数据" :columns="columns" :data="data">

            <template slot-scope="{ row }" slot="action">
              <Button @click="openDetail(row.guid,row.applicationType)" type="info" ghost style="margin-right: 5px">详情</Button>
              <!-- <Button @click="openEdit(row.guid,row.applicationType)" v-if="row.allow编辑" type="warning" ghost style="margin-right: 5px">修改</Button> -->
              <Button @click="deleteHandler(row.guid)" ghost type="error" v-if="row.allowDelete" style="margin-right: 5px">删除</Button>
              <!-- <Button @click="openDownLoad(row.guid)" type="warning" ghost style="margin-right: 5px">下载调档函</Button> -->
              <!-- <Button @click="subDownLoad(row.guid)" type="warning" ghost v-if="row.allow下载调档函" style="margin-right: 5px">下载调档函</Button>
              <Button @click="openMail(row.guid)" type="warning" ghost v-if="row.allow已邮寄调档函" style="margin-right: 5px">已邮寄调档函</Button> -->
            </template>
          </Table>
        </div>
        <div class="page_btn">
          <Page :total="page.total" show-elevator show-total show-sizer v-model="page.current" @on-prev="pageCurrent" @on-next='pageCurrent' @on-page-size-change="pageSizeChange" @on-change="pageCurrent" />
        </div>

      </div>
    </Card>
    <!-- <Modal v-model="showPropress" width="460" title="下载调档函">
      <div>
        请下载档案核实函及档案核实情况表并邮寄。
      </div>
      <template #footer>
        <Button type="primary" @click="subDownLoad">开始下载</Button>
      </template>
    </Modal> -->
  </div>
</template>

<script>
// import Detail from '../detail/index.vue'
export default {
  components: {
    //  ProgressBar,
  },
  data() {
    return {
      accept: '.xls, .xlsx',
      loading: false,
      showDetail: false,
      detailId: null,
      detailTitle: '',
      appSourceTypeList: [],
      statusList: [],
      progress: 0,
      downLoadGuid: '',
      showPropress: false,
      queryForm: {
        // wxOpenId: '',
        // startCreateTime: '',
        // endCreateTime: '',
        // testType: '',
        // time: [],
        query_续办综合查询: true,
      }, //查询参数
      page: {
        //分页参数
        total: 0,
        current: 0,
        skipCount: 0,
        maxResultCount: 10,
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 80,
        },
        {
          title: '流水号',
          key: 'applicationNo',
        },
        {
          title: '申请人姓名',
          key: 'applicantName',
        },
        {
          title: '身份证号码',
          key: 'applicantIDCardNo',
          width: 185,
        },

        {
          title: '提交时间',
          key: 'submitTime',
        },
        {
          title: '状态',
          key: 'statusText',
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
        },
      ],
      data: [],
      types: [],
    }
  },
  mounted() {
    this.getData()
    this.getSelectList()
  },
  methods: {
    queryTable() {
      this.page = {
        //分页参数
        total: 0,
        current: 0,
        skipCount: 0,
        maxResultCount: 10,
      }
      this.getData()
    },
    async getSelectList() {
       let { data } = await this.$Ajax.get('/api/services/app/JZZJFApi/GetBasicData')
      console.log('🚀 ~ file: index.vue:213 ~ getSelectList ~ data:', data)
      this.appSourceTypeList = data.result.appSourceTypeList
      this.statusList = data.result.statusList
    },
    //分页 改变当前页码
    pageCurrent(current) {
      this.page.current = current
      this.page.skipCount = (current - 1) * this.page.maxResultCount
      this.getData()
    },
    //分页改变每页条数
    pageSizeChange(pageSizeChange) {
      this.page.maxResultCount = pageSizeChange
      this.pageCurrent(1)
    },
    //获取所有类型

    //时间格式化
    dateChange() {
      let time = this.queryForm.time
      console.log('🚀 ~ file: article.vue:257 ~ dateChange ~ time:', time)
      let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
      let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
      this.queryForm.startCreateTime = start
      this.queryForm.endCreateTime = end
    },
    //打开详情
    openDetail(guid) {
      this.$router.push({ name: 'renewalPoinsDetail', query: { guid, type: 8 } })
    },
    //打开编辑
    openEdit(guid, type) {
      this.$router.push({ name: 'otherApplications', query: { guid, type } })
    },
    //下载调档函
    openDownLoad(guid) {
      this.showPropress = true
      let _this = this
      this.downLoadGuid = guid
    },
    //确认下载
    async subDownLoad(guid) {
      let _this = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>请下载档案核实函及档案核实情况表并邮寄</p>',
        okText: '下载',
        cancelText: '否',
        onOk: async () => {
          this.$Ajax
            .get('/jzzjf/jzzjfapi/DownloadDDH?guid=' + guid, {
              responseType: 'blob',
              onDownLoadProgress: (progressEvent) => {
                console.log(
                  '🚀 ~ file: index.vue:240 ~ subDownLoad ~ progressEvent:',
                  progressEvent
                )
                _this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
              },
            })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'file.pdf')
              document.body.appendChild(link)
              link.click()
              _this.$Message.success({
                content: '下载成功',
                background: true,
                duration: 6,
              })
              _this.getData()
            })

            .catch((error) => {
              _this.showPropress = false
              _this.$Message.error({
                content: '下载失败',
                background: true,
                duration: 6,
              })
            })
        },
        onCancel: () => {
          //否，个人信息变更
          //this.$emit('next', _this.current_index + 1)
        },
      })

      // this.showPropress = false
    },
    //邮寄调档函
    openMail(guid) {
      let _this = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否邮寄档案核实函及档案核实情况表</p>',
        okText: '是',
        cancelText: '否',
        onOk: async () => {
          // 是 直接提交
          try {
            let { data } = await _this.$Ajax.get(
              '/api/services/app/JZZJFApi/MailedFilesVerification?guid=' + guid
            )
            _this.$Message.success({
              content: '操作成功',
              background: true,
              duration: 6,
            })
            _this.getData()
          } catch (error) {
            _this.$Message.error({
              content: '操作失败',
              background: true,
              duration: 6,
            })
          }
        },
        onCancel: () => {
          //否，个人信息变更
          //this.$emit('next', _this.current_index + 1)
        },
      })
    },
    //TODO 删除信息
    deleteHandler(guid) {
      let _this = this
      this.$Modal.confirm({
        title: '确定删除此申请吗',
        okText: '是',
        cancelText: '否',
        onOk: async () => {
          // 是 直接提交
          let { data } = await _this.$Ajax.get(
            'api/services/app/JZZJFApi/DelApplication?guid=' + guid
          )
          _this.$Message.success({
            content: '删除成功',
            background: true,
            duration: 6,
          })
          _this.getData()
        },
        onCancel: () => {
          //否，个人信息变更
          //this.$emit('next', _this.current_index + 1)
        },
      })
    },
    //查询
    async getData() {
      this.loading = true
      let params = { ...this.queryForm, ...this.page }
      let { data } = await this.$Ajax.post(
        '/api/services/app/JZZJFApi/GetXBApplicationList',
        params
      )
      if (data.success) {
        this.page.total = data.result.totalCount
        this.data = data.result.items
      }
      this.loading = false
    },
    //重置
    refresh(name) {
      this.$refs[name].resetFields()

      if ((name = 'infoFrom')) {
        this.queryForm = {
          query_续办综合查询: true,
        } //查询参数
        this.page = {
          //分页参数
          total: 0,
          current: 1,
          skipCount: 0,
          maxResultCount: 10,
        }

        this.getData()
      }
    },

    downLoad(url, name) {
      this.$downLoad(url, name)
    },
  },
}
</script>

<style lang="less" scoped>
.g {
  color: green;
}
.r {
  color: rgb(153, 153, 153);
}
.o {
  color: orange;
}
.editForm {
  .ivu-form-item {
    margin-right: 58px;
  }
}
.ivu-page {
  margin-top: 20px;
}
.role {
  .ivu-switch {
    margin-right: 10px;
  }
}

.table_btn {
  margin-top: 10px;
}
.ivu-divider-horizontal.ivu-divider-with-text-left,
.ivu-divider-horizontal.ivu-divider-with-text-right {
  font-size: 16px;
  color: #57a3f3;
}
.page_btn {
  display: flex;
}
.page_button {
  margin-top: 20px;
  button {
    margin-right: 10px;
  }
}
.divi {
  cursor: pointer;
}
.tab_btn {
  display: flex;
  justify-content: right;
  margin-bottom: 5px;
}

.button {
  * {
    margin-right: 10px;
  }
}
.ivu-alert-icon2 {
  font-size: 16px;
  top: 6px;
  left: 12px;
}
.function /deep/.ivu-form-item-content {
  margin-left: 10px !important;
}
/deep/.ivu-alert-icon {
  font-size: 16px;
  top: 8px;
  left: 12px;
  position: absolute;
}

/deep/.ivu-table-expanded-cell {
  padding: 0px 0px 0px 50px;
}
/deep/.rowClassName {
  background-color: #f8f8f9 !important;
  color: rgb(0, 0, 0);
}
// /deep/.ivu-table-expanded-cell /deep/td {
//   background: orange;
// }
</style>

       